export class JsonResponseError
{
	/** @type {string} */
	message;

	/** @type {string|number} */
	code;

	/** @type {object|array|null} */
	data;

	static UnknownReason = 'Unknown error occurred.';

	constructor(message, code, data)
	{
		this.message = message || JsonResponseError.UnknownReason;
		this.code = code || 0;
		this.data = data || null;
	}

	static fromObject(error)
	{
		return new JsonResponseError(error.message, error.code, error.data);
	}
}

window.App = window.App || {};
window.App.JsonResponseError = JsonResponseError;
